export default __webpack_public_path__ + "static/media/work-5.3c3c7ebc.png";